import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { SubmissionAttachment } from '../../../../models/submissions/submission-attachment';
import { FileDownloadService } from '../../../../services/file-download/file-download.service';
import { TrackByUtils } from '../../../../utils/track-by-utils';

@Component({
  selector: 'app-fiduciary-submission-submitted-file-list',
  templateUrl: './fiduciary-submission-submitted-file-list.component.html',
  styleUrls: ['./fiduciary-submission-submitted-file-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FiduciarySubmissionSubmittedFileListComponent {
  @Input() files: SubmissionAttachment[] = [];
  @Input() receivedDate: string = '';

  public readonly fileDownloadService = inject(FileDownloadService);
  public readonly trackById = TrackByUtils.trackById;
}
